import React from "react";
import { formatRelativeTime } from "../utils/formatTime";

interface Props {
  createdBy: string;
  createdAt: number;
  text: string;
}

export function CommentItem({ createdBy, createdAt, text }: Props) {
  return (
    <div className="rounded-md bg-gray-50 dark:bg-gray-600 px-3 py-2">
      <div className="flex items-baseline gap-1.5 flex-wrap">
        <span className="text-xs font-semibold text-gray-800 dark:text-gray-200">{createdBy}</span>
        <span className="text-xs text-gray-400 dark:text-gray-400">{formatRelativeTime(createdAt)}</span>
      </div>
      <p className="text-xs text-gray-600 dark:text-gray-300 mt-0.5 whitespace-pre-wrap leading-relaxed">{text}</p>
    </div>
  );
}
